// extracted by mini-css-extract-plugin
export var closed = "_bf-1";
export var resizer = "_bf-0";